export default "__VITE_ASSET__BjHmT5DY__"